









import Vue from 'vue';

export default Vue.extend({
  components: {},
  props: {},
  data(): {
    TBD: undefined;
  } {
    return {
      TBD: undefined,
    };
  },
  methods: {},
});
